import { observer } from 'mobx-react-lite';

import { MainLayoutUserPreferencesButton } from '../../../react-router/layouts/MainLayout/MainLayoutUserPreferences/MainLayoutUserPreferencesButton';
import { useAuthStore } from '../../../stores/authStore';
import { withEnableInViewOnlyMode, withHideActionFromViewOnly } from '../../../utilities/withAttributes';
import { useEmrName } from '../../../utils/useEMRName';
import { useNavinaData } from '../../../utils/useNavinaData';
import { UserSettings } from './UserSettings';

export const UserMenuPopup = observer(function UserMenuPopup() {
	const authStore = useAuthStore();
	const emrName = useEmrName();
	const { isOverlayOrEmbedded } = useNavinaData();

	const showSignOut = !authStore.getIsSAML || authStore.isAdmin;
	const isShowingSettings = (emrName === 'athena' || authStore.admin) && !isOverlayOrEmbedded;

	const settings = isShowingSettings ? (
		<div {...withHideActionFromViewOnly}>
			<UserSettings />
		</div>
	) : null;

	const signOut = (): void => {
		void authStore.logoutAndRedirectToLoginPage();
	};

	return (
		<MainLayoutUserPreferencesButton
			{...{ userName: authStore.getEmail, showSignOut, onSignOut: signOut, settings, ...withEnableInViewOnlyMode }}
		/>
	);
});
